import React from "react";
import Radio from "antd/lib/radio";
import {
  SurveyQuestionCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface NauseaVomitingSectionProps {
  readonly currentPage: number;
}

export const NauseaVomitingSection: React.FC<NauseaVomitingSectionProps> = ({
  currentPage
}) => {
  return (
    <>
      {currentPage === 7 && (
        <SurveyQuestionCard
          sectionTag="NAUSEA / VOMITING"
          title="Have you had any nausea or vomiting during dialysis recently?"
          required
        >
          <FormItemStyle
            name="Have you had nausea or vomiting"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("haveYouHadNauseaOrVomiting")}
              onChange={e => {
                localStorage.setItem(
                  "haveYouHadNauseaOrVomiting",
                  e.target.value
                );
              }}
            >
              <AnswerList>
                <AnswerOption value="None">None</AnswerOption>
                <AnswerOption value="Rarely (1 - 2 / Month)">
                  Rarely (1 - 2 / Month)
                </AnswerOption>
                <AnswerOption value="Occasional (3 - 4 / Month)">
                  Occasional (3 - 4 / Month)
                </AnswerOption>
                <AnswerOption value="Frequent (5 - 10 / Month)">
                  Frequent (5 - 10 / Month)
                </AnswerOption>
                <AnswerOption value="Every dialysis (11 - 13 / Month)">
                  Every dialysis (11 - 13 / Month)
                </AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
    </>
  );
};
